
import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type Props = {
  onClickCancel: () => void
  onClickConfirm: () => void
}
const CancelModal = ({ onClickCancel, onClickConfirm }: Props) => {
  const onSubmit = async () => {
    onClickConfirm()
  }
  const onCloseModal = () => {
    onClickCancel()
  }
  return (
    <Modal
      title={i18n.t('settings.locations.map.cancel_modal.title')}
      illustration="alert"
      description={i18n.t('settings.locations.map.cancel_modal.description')}
      onClose={onCloseModal}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onCloseModal}>
            {i18n.t('settings.locations.map.cancel_modal.cancel')}
          </Button>
          <Button submit>{i18n.t('settings.locations.map.cancel_modal.confirm')}</Button>
        </>
      }
    ></Modal>
  )
}

export default observer(CancelModal)
